import React from 'react';
import { BottomNavigation } from './BottomNavigation';
import { useSettings } from '../contexts/SettingsContext';
export function AppShell({
  children
}: {
  children: React.ReactNode;
}) {
  const {
    accessibility
  } = useSettings();
  return <div className="flex min-h-screen w-full justify-center bg-deeper" data-id="element-556" data-mp="nm9aq3hc3vqp">
      <div className={`relative flex min-h-screen w-full max-w-app flex-col bg-sand shadow-lift ${accessibility.reduceMotion ? 'bee-reduce-motion' : ''}`} style={{
      fontSize: accessibility.largerText ? '17.5px' : undefined,
      ...(accessibility.increaseContrast ? {
        ['--bee-muted' as string]: '#31423b',
        ['--bee-line' as string]: '#b8af99'
      } as React.CSSProperties : {})
    }} data-id="element-557" data-mp="sku8zxd105ci">
        <main className="flex-1 pb-3 pt-[env(safe-area-inset-top)]" data-id="element-558" data-mp="1z6ofrv9vv7iz">{children}</main>
        <BottomNavigation data-id="element-559" data-mp="23zzmlwep3oaw" />
      </div>
    </div>;
}